<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">
                <FormDynamic
                    name="form_1"
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <DischargesForm :single_object="single_object"/>

                <FormDynamic
                    style="margin-top: -50px !important"
                    name="form_2"
                    :form_format="form_format_note"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <CentralButtons /> 
                
            </form>
        </template>
    <WaitingModal/>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import WaitingModal     from    '@/components/WaitingModal'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'
import DischargesForm   from '../StaffingScenariosV2/DischargesForm';

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
        
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
        DischargesForm,
        WaitingModal
    },

    data(){
        return{
            form_format:    FormResources.form_format,
            form_format_note: FormResources.form_format_note
        }
    },
    
    methods:{
    },

    mounted(){

    }
    
}
</script>
